import React, { useState } from 'react'
import { Dialog } from '../../../common/Dialog'
import { logError } from '@tomra/datadog-browser-logging'
import { Badge } from '@tomra/design-system-react/badge'

export const AddNote = ({
  charity,
  updateNote
}: {
  charity: CharitySummaryType
  updateNote: (charityId: string, note: string) => Promise<void>
}) => {
  const [showEditDialog, setShowEditDialog] = useState(false)
  const [requestStatus, setRequestStatus] = useState<RequestStatusType>('idle')

  const _updateNote = async (note: string) => {
    try {
      setRequestStatus('pending')
      await updateNote(charity.id, note)
      setRequestStatus('success')
      setShowEditDialog(false)
    } catch (error: any) {
      setRequestStatus('failure')
      logError(new Error('Failed to set charity note'), error)
    }
  }

  return (
    <>
      <button aria-label="add note" onClick={() => setShowEditDialog(!showEditDialog)}>
        <Badge variant={charity.note ? 'warning' : 'default'}>{charity.note || `Add note`}</Badge>
      </button>

      {showEditDialog && (
        <Dialog ariaLabel="Add note dialog" onClose={() => setShowEditDialog(false)}>
          <div className="card min-w-screen-sm p-xl">
            <h1 className="text-center mb-lg text-xl">Set a status</h1>

            {requestStatus === 'failure' && (
              <div className="alert danger mb-lg">Something went wrong. Please try again later.</div>
            )}

            <div className=" flex items-center justify-center space-x-md">
              {requestStatus === 'pending' ? (
                <div className="loadingSpinner self-center" />
              ) : (
                <>
                  <button className="tag tag-orange" onClick={() => _updateNote('Awaiting feedback')}>
                    Awaiting feedback
                  </button>
                  <button className="tag tag-orange" onClick={() => _updateNote('On hold')}>
                    On hold
                  </button>
                  <button className="tag" onClick={() => _updateNote('')}>
                    Reset
                  </button>
                </>
              )}
            </div>
          </div>
        </Dialog>
      )}
    </>
  )
}
